import { useState ,useEffect} from 'react';
import React from "react";
import { BASE_URL } from '../Components/Constant';
import ApiService from '../Components/apiService';
import { EditOutlined, CopyOutlined, DeleteOutlined, PhoneOutlined, CloseOutlined } from '@ant-design/icons';
import { Table,Checkbox, Typography, Tooltip, Popconfirm, Button, message, Card, Row,Col,Input,Select,Affix } from 'antd';
import { Editor } from "@monaco-editor/react";


const CreateTigger=({object,onBack,fetchAllTriggers,selectedTrigger,selectedTriggerData,triggerId})=>{

    
    const { Option } = Select;
    const { Title } = Typography;
    const [modelName,setModelName]=useState(object?.name);
    const [code, setCode] = useState("# Write your Ruby script here");
    const [errorMessage, setErrorMessage] = useState('');
    const [isActive,setIsActive] = useState(false);
    const [order,setOrder]= useState('');
    const [triggerName,setTriggerName] = useState('');
    useEffect(()=>{

        if(selectedTriggerData){
            setCode(selectedTrigger);
            setOrder(selectedTriggerData.order);
            setIsActive(selectedTriggerData.isActive);
            setIsActive(selectedTriggerData.active || false); 
            setTriggerName(selectedTriggerData.trigger_name|| '');
        }
        else{
            setCode('class #TriggerName #Trigger Name must end with Trigger\n    def before_create(context,old_context)\n        #before_create code\n    end\n\n    def after_create(context,old_context)\n        #after_create code\n    end\n\n    def before_update(context,old_context)\n        #before_update code\n    end\n\n    def after_update(context,old_context)\n        #after_update code\n    end\n\n    def before_destroy(context,old_context)\n        #before_destroy code\n    end\n\n    def after_destroy(context,old_context)\n        #after_destroy code\n    end\nend'); 
            setIsActive(false);
            setOrder('');
            setTriggerName('TriggerName');
        }

    },[selectedTriggerData])

    


    const handleSave=async(data)=>{
      
        
        if(triggerId){
            
        }
        const body={
            "trigger_metadata": {
                "model_name": modelName,
                "trigger_content": code,
                "trigger_name": triggerName,
                "order":order,
                "active":isActive,
              }
        }
        if (triggerId) {
            body.trigger_metadata._id = triggerId;
          }


        let apiService='';
            apiService = new ApiService(
                `${BASE_URL}/create_or_update_trigger/`,
                { 'Content-Type': 'application/json' },
                'POST',
                body
              ); 
        

        try{
            const res=await apiService.makeCall();
            if (triggerId) {
                message.success('Trigger updated Successfully');

              } else{
                message.success('Trigger created Successfully');
              }
            setModelName('');
            fetchAllTriggers();
            onBack();
        }
        catch(error){

            const errorMessage = error && typeof error === 'object'
                    ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                    : 'Failed to save trigger due to an unknown error';
                  message.error(errorMessage);

        }

    }

    const handleCancel=()=>{
        setModelName('');
        setOrder('');
        setIsActive(false);
        setTriggerName('');
        onBack();
        
    }
    const callOnBack = ()=>{
        setModelName('');
        setOrder('');
        setIsActive(false);
        setTriggerName('');
        onBack();   
    }

      const handleCodeChange = (value) => {
        setCode(value || '');
        setErrorMessage(''); // Clear previous errors
    
        // Extract class name from the code
        const classNameMatch = value?.match(/class\s+([A-Za-z0-9_]+)/);
        if (classNameMatch) {
            setTriggerName(classNameMatch[1]);
        } else {
            setTriggerName(''); // Reset if class name is not found
        }
    };
    


    return(
        <>
            <Card>
                <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
                        <Col>
                        <Title level={3}>{triggerName}</Title>
                        </Col>
                        <Col>
                        <Button type="default" onClick={()=>callOnBack()}>
                        Back
                        </Button>
                        </Col>
                </Row>

                <div>
                    <Row gutter={[16, 24]} align="middle">
                        {/* Checkbox for Active */}
                        <Col span={12}>
                            <Checkbox 
                                checked={isActive} 
                                onChange={(e) => setIsActive(e.target.checked)} // Update active state
                                style={{ marginBottom: '8px' }}
                            >
                                Active
                            </Checkbox>
                        </Col>

                        {/* Input for Order */}
                        <Col span={12}>
                            <label htmlFor="orderField" style={{ marginBottom: '8px', display: 'block' }}>
                                Order
                            </label>
                            <Input
                                id="orderField"
                                type="number"
                                placeholder="Enter order"
                                value={order} // Bind the order state
                                onChange={(e) => setOrder(Number(e.target.value))} // Update order state
                                style={{
                                    width: '80%',
                                    padding: '8px',
                                    fontSize: '10px',
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <div style={{ width: '100%', marginBottom: '5px' ,marginTop: '22px' }}>

                            <h3>Help</h3>
                                <ul>
                                <li>
                                    <strong>Get new record context:</strong> Use the <code>context</code> variable.
                                </li>
                                <li>
                                    <strong>Get old record context:</strong> Use the <code>old_attributes</code> variable.
                                </li>
                                <li>
                                    <strong>Trigger Name will automatically match with the below Trigger Name.</strong>
                                </li>
                                </ul>
                        </div>
                    </Row>
                </div>
            </Card>
            <Card style={{ marginTop: '16px' }}>
            <label htmlFor="script" style={{ marginBottom: '8px', display: 'block' }}><code>Write your script here...</code></label>
                <div style={{ height: "400px", border: "1px solid #ddd" }}>
                    {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
                    <Editor
                        height="100%"
                        defaultLanguage="ruby"
                        theme="vs-light"
                        value={code}
                        onChange={(value) => handleCodeChange(value)}
                    />
                </div>
            </Card>
            <Affix offsetBottom={0}>
                <div
                    style={{
                        position: "sticky",
                        bottom: 0,
                        background: 'rgba(240, 242, 245, 0.9)', 
                        padding: "10px 0",
                        boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                    }}
                >
                        
                    <Button type="primary" onClick={handleSave} style={{ marginRight: 10 }}>
                        Save Trigger
                    </Button>
                    <Button type="default" onClick={handleCancel}>
                        Cancel
                    </Button>
                </div>
            </Affix>
        </>
    );

}

export default CreateTigger;